import useTranslation from 'hooks/useTranslation'
import Submit from 'components/inputs/Submit'
import Popup from 'components/popups/Popup'
import { useSelector } from 'react-redux'
import { selectForm } from '../formSlice'
import Loading from 'components/Loading'
import { STATUS } from 'utils/constants'

const ConfirmationPopup = ({ status, submit, close }) => {
  const { phone = '' } = useSelector(selectForm)
  const { t } = useTranslation('form')

  return (
    <Popup close={() => status === STATUS.idle && close()}>
      <div className='popup__verification'>
        <i className='icon icon--logo s24' />
        <h2>{t('authorization')}</h2>

        <div className='verification__text'>
          <div>{t('weWillSendAnSmsWithAVerificationCode-array')?.[0]}</div>
          <div>{t('weWillSendAnSmsWithAVerificationCode-array')?.[1]}:</div>
        </div>

        <div className='verification__phone'>
          {status === STATUS.pending
            ? <Loading />
            : <>
              <h2>{phone.replace(/^([\d]{3})([\d]{3})([\d]{3})$/, '$1 $2 $3')}</h2>
              <div
                className='verification__button'
                onClick={close}>
                {t('change')}
              </div>
            </>}
        </div>

        <Submit
          text={t('sendCode')}
          block={status === STATUS.pending}
          action={submit} />
      </div>
    </Popup>
  )
}

export default ConfirmationPopup